export const Types = {
  SIGN_IN: 'SIGN_IN',
  SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
  COGNITO_SIGN_IN_SUCCESS: 'COGNITO_SIGN_IN_SUCCESS',
  SIGN_IN_FAIL: 'SIGN_IN_FAIL',
  CLEAR_UI_STATE: 'SIGN_IN/CLEAR_UI_STATE',
};

export const signInSuccess = (payload) => ({
  type: Types.SIGN_IN_SUCCESS,
  payload,
});

export const cognitoSignInSuccess  = (payload) => ({
  type: Types.COGNITO_SIGN_IN_SUCCESS,
  payload,
});

export const signInFail = (error) => ({
  type: Types.SIGN_IN_FAIL,
  payload: { error },
});

// Used when we intentionally redirect away from auth screens and need to clear transient UI state.
export const clearUiState = () => ({
  type: Types.CLEAR_UI_STATE,
});

export const onSignIn = (email, password) => ({
  type: Types.SIGN_IN,
  payload: { email, password },
});
